export default __webpack_public_path__ + "static/media/trangiaNatur.01745037.jpg";